import React, { useEffect, useMemo, useState, useRef } from "react";
import { useTable, useSortBy } from "react-table";
import api from "../components/api/api";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableSortLabel,
  Button,
} from "@mui/material";
import { Check, CheckBox } from "@mui/icons-material";
import { formatDistanceToNow } from "date-fns";
import { es } from "date-fns/locale";

const MQL4Page = ({ setAccountsCount, setTotalProfit, mql4Protocol, setMql4Protocol }) => {
  const [data, setData] = useState([]);
  const [sortBy, setSortBy] = useState([]);
  const [a1Checked, setA1Checked] = useState({});
  const a1CheckedRef = useRef(a1Checked);
  const [a2Checked, setA2Checked] = useState({});
  const a2CheckedRef = useRef(a2Checked);
  const [a3Checked, setA3Checked] = useState({});
  const a3CheckedRef = useRef(a3Checked);
  const [a4Checked, setA4Checked] = useState({});
  const a4CheckedRef = useRef(a4Checked);
  const [fixedChecked, setFixedChecked] = useState({});
  const fixedCheckedRef = useRef(fixedChecked);

  useEffect(() => {
    a1CheckedRef.current = a1Checked;
  }, [a1Checked]);

  useEffect(() => {
    a2CheckedRef.current = a2Checked;
  }, [a2Checked]);

  useEffect(() => {
    a3CheckedRef.current = a3Checked;
  }, [a3Checked]);

  useEffect(() => {
    a4CheckedRef.current = a4Checked;
  }, [a4Checked]);

  useEffect(() => {
    fixedCheckedRef.current = fixedChecked;
  }, [fixedChecked]);

  const getData = async () => {
    api.getMQL4Accounts(
      (res) => {
        res.accounts.forEach((row) => {
          row.lastUpdated = getTimeFromDateTime(row.lastUpdated);
          /*row.a1 = a1CheckedRef.current[row.accountId] || false;
          row.a2 = a2CheckedRef.current[row.accountId] || false;
          row.a3 = a3CheckedRef.current[row.accountId] || false;
          row.a4 = a4CheckedRef.current[row.accountId] || false;
          row.fixed = fixedCheckedRef.current[row.accountId] || false;*/
        });

        setData(res.accounts);
        setAccountsCount(res.accounts.length);
        setTotalProfit(null);
        setMql4Protocol(res.config.protocol);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  // Llamar a getData cada 5 segundos
  React.useEffect(() => {
    getData();
    const interval = setInterval(() => {
      getData();
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const handleDelete = (accountId) => {
    setData((prevData) => prevData.filter((row) => row.accountId !== accountId));
    api.deleteMQL4Account(
      accountId,
      () => {
        console.log("Cuenta eliminada");
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const getTimeFromDateTime = (dateTime) => {
    return new Date(dateTime);
    const date = new Date(dateTime);
    return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds().toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    setData((prevData) => prevData.map((row) => ({ ...row, a1: a1Checked[row.accountId] })));
  }, [a1Checked]);

  useEffect(() => {
    setData((prevData) => prevData.map((row) => ({ ...row, a2: a2Checked[row.accountId] })));
  }, [a2Checked]);

  useEffect(() => {
    setData((prevData) => prevData.map((row) => ({ ...row, a3: a3Checked[row.accountId] })));
  }, [a3Checked]);

  useEffect(() => {
    setData((prevData) => prevData.map((row) => ({ ...row, a4: a4Checked[row.accountId] })));
  }, [a4Checked]);

  useEffect(() => {
    setData((prevData) => prevData.map((row) => ({ ...row, fixed: fixedChecked[row.accountId] })));
  }, [fixedChecked]);

  const handleMQL4A1Update = (accountId, value) => {
    const data = {
      a1: value,
    };
    api.updateMQL4Account(
      accountId,
      data,
      (res) => {
        console.log(res);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleMQL4A2Update = (accountId, value) => {
    const data = {
      a2: value,
    };
    api.updateMQL4Account(
      accountId,
      data,
      (res) => {
        console.log(res);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleMQL4A3Update = (accountId, value) => {
    const data = {
      a3: value,
    };
    api.updateMQL4Account(
      accountId,
      data,
      (res) => {
        console.log(res);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleMQL4A4Update = (accountId, value) => {
    const data = {
      a4: value,
    };
    api.updateMQL4Account(
      accountId,
      data,
      (res) => {
        console.log(res);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const handleMQL4FixedUpdate = (accountId, value) => {
    const data = {
      fixed: value,
    };
    api.updateMQL4Account(
      accountId,
      data,
      (res) => {
        console.log(res);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const columns = useMemo(
    () => [
      { Header: "Email", accessor: "email" },
      { Header: "Número de cuenta", accessor: "accountId" },
      { Header: "Balance", accessor: "balance" },
      { Header: "Equidad", accessor: "equity" },
      { Header: "Margen", accessor: "margin" },
      { Header: "Margen Libre", accessor: "freeMargin" },
      { Header: "Nivel de Margen", accessor: "marginLevel" },
      {
        Header: "Flotante",
        accessor: "floatingNegative",
        Cell: ({ row }) => {
          const floatingNegative = row.original.equity - row.original.balance;
          return <span>{floatingNegative.toFixed(2)}</span>;
        },
        sortType: (rowA, rowB) => {
          const floatingA = rowA.original.equity - rowA.original.balance;
          const floatingB = rowB.original.equity - rowB.original.balance;
          return floatingA - floatingB;
        },
      },
      {
        Header: "A1",
        accessor: "a1",
        Cell: ({ row }) => (
          <Button
            sx={{ backgroundColor: "transparent", color: "white", height: "20px" }}
            onClick={() => {
              setA1Checked((prev) => ({
                ...prev,
                [row.original.accountId]: !row.original.a1,
              }));
              handleMQL4A1Update(row.original.accountId, !row.original.a1);
            }}
          >
            {row.original.a1 && <Check />}
          </Button>
        ),
        sortType: (rowA, rowB) => {
          return rowB.original.a1 - rowA.original.a1;
        },
      },
      {
        Header: "A2",
        accessor: "a2",
        Cell: ({ row }) => (
          <Button
            sx={{ backgroundColor: "transparent", color: "white", height: "20px" }}
            onClick={() => {
              setA2Checked((prev) => ({
                ...prev,
                [row.original.accountId]: !row.original.a2,
              }));
              handleMQL4A2Update(row.original.accountId, !row.original.a2);
            }}
          >
            {row.original.a2 && <Check />}
          </Button>
        ),
        sortType: (rowA, rowB) => {
          return rowB.original.a2 - rowA.original.a2;
        },
      },
      {
        Header: "A3",
        accessor: "a3",
        Cell: ({ row }) => (
          <Button
            sx={{ backgroundColor: "transparent", color: "white", height: "20px" }}
            onClick={() => {
              setA3Checked((prev) => ({
                ...prev,
                [row.original.accountId]: !row.original.a3,
              }));
              handleMQL4A3Update(row.original.accountId, !row.original.a3);
            }}
          >
            {row.original.a3 && <Check />}
          </Button>
        ),
        sortType: (rowA, rowB) => {
          return rowB.original.a3 - rowA.original.a3;
        },
      },
      {
        Header: "A4",
        accessor: "a4",
        Cell: ({ row }) => (
          <Button
            sx={{ backgroundColor: "transparent", color: "white", height: "20px" }}
            onClick={() => {
              setA4Checked((prev) => ({
                ...prev,
                [row.original.accountId]: !row.original.a4,
              }));
              handleMQL4A4Update(row.original.accountId, !row.original.a4);
            }}
          >
            {row.original.a4 && <Check />}
          </Button>
        ),
        sortType: (rowA, rowB) => {
          return rowB.original.a4 - rowA.original.a4;
        },
      },
      {
        Header: "Marcar",
        accessor: "fixed",
        Cell: ({ row }) => (
          <Button
            sx={{ backgroundColor: "transparent", color: "white", height: "20px" }}
            onClick={() => {
              setFixedChecked((prev) => ({
                ...prev,
                [row.original.accountId]: !row.original.fixed,
              }));
              handleMQL4FixedUpdate(row.original.accountId, !row.original.fixed);
            }}
          >
            {row.original.fixed && <Check />}
          </Button>
        ),
        sortType: (rowA, rowB) => {
          return rowB.original.fixed - rowA.original.fixed;
        },
      },
      {
        Header: "Última actualización",
        accessor: "lastUpdated",
        Cell: ({ row }) => {
          const validDate = new Date(row.original.lastUpdated);
          if (isNaN(validDate)) throw new Error("Invalid date");

          const now = new Date();
          const diffInSeconds = Math.floor((now - validDate) / 1000);

          let timeAgo;
          if (diffInSeconds < 60) {
            timeAgo = `hace ${diffInSeconds} segundos`;
          } else {
            timeAgo = formatDistanceToNow(validDate, {
              addSuffix: true,
              locale: es,
            });
          }

          return <span>{timeAgo}</span>;
        },
        sortType: (rowA, rowB) => {
          const dateA = new Date(rowA.original.lastUpdated);
          const dateB = new Date(rowB.original.lastUpdated);

          if (isNaN(dateA) && isNaN(dateB)) return 0;
          if (isNaN(dateA)) return 1;
          if (isNaN(dateB)) return -1;

          return dateA - dateB;
        },
      },
      {
        Header: "Acciones",
        id: "actions",
        Cell: ({ row }) => (
          <Button
            onClick={() => handleDelete(row.original.accountId)}
            sx={{ backgroundColor: "transparent", color: "red", height: "20px" }}
          >
            Eliminar
          </Button>
        ),
      },
    ],
    []
  );

  const getSortedData = (data) => {
    return [...data].sort((a, b) => {
      if (a.fixed === b.fixed) return 0;
      return b.fixed ? 1 : -1;
    });
  };

  const sortedData = useMemo(() => getSortedData(data), [data]);

  const tableInstance = useTable(
    {
      columns,
      data: sortedData,
      initialState: { sortBy },
    },
    useSortBy
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, state } = tableInstance;

  React.useEffect(() => {
    setSortBy(state.sortBy);
  }, [state.sortBy]);

  const getCellColor = (row, cell) => {
    if (row.original.margin == 0) return "transparent";
    if (cell.column.id === "margin") {
      if (mql4Protocol == "B" && row.original.email != "LIB1" && !row.original.email.includes("NEST")) {
        if (row.original.fixed) return "purple";
        return "transparent";
      }
      if (row.original.email == "LIB1" || row.original.email.includes("NEST") || mql4Protocol == "B") {
        if (row.original.margin > 3000) return "#2303AC";
        if (row.original.margin > 2500) return "#003AFE";
        if (row.original.margin > 2000) return "#00A3FE";
        if (row.original.margin > 1000) return "#00E4FF";
        if (row.original.margin > 800) return "#04FEFD";
      } else {
        if (row.original.margin > 4000) return "#2303AC";
        if (row.original.margin > 3500) return "#003AFE";
        if (row.original.margin > 3000) return "#00A3FE";
        if (row.original.margin > 2000) return "#00E4FF";
        if (row.original.margin > 1000) return "#04FEFD";
      }
      if (row.original.fixed) return "purple";
      return "green";
    }
    if (cell.column.id === "marginLevel") {
      if (row.original.email == "LIB1" || row.original.email.includes("NEST") || mql4Protocol == "B") {
        if (row.original.marginLevel < 250) return "#FB0006";
        if (row.original.marginLevel < 800) return "#FF6D00";
        if (row.original.marginLevel < 1000) return "#FEAC01";
        if (row.original.marginLevel < 1200) return "#7E6000";
        if (row.original.marginLevel < 1400) return "#D6A6BE";
      } else {
        if (row.original.marginLevel < 150) return "#FB0006";
        if (row.original.marginLevel < 300) return "#FF6D00";
        if (row.original.marginLevel < 400) return "#FEAC01";
        if (row.original.marginLevel < 500) return "#7E6000";
        if (row.original.marginLevel < 800) return "#D6A6BE";
      }

      if (row.original.fixed) return "purple";
      return "green";
    }

    if (row.original.fixed) return "purple";
    return "transparent";
  };

  const getCellTextColor = (row, cell) => {
    if (row.original.margin == 0) return "white";
    if (cell.column.id === "margin") {
      if (mql4Protocol == "B" && row.original.email != "LIB1" && !row.original.email.includes("NEST")) {
        return "white";
      }
      if (row.original.email == "LIB1" || row.original.email.includes("NEST") || mql4Protocol == "B") {
        if (row.original.margin > 3000) return "white";
        if (row.original.margin > 2500) return "white";
        if (row.original.margin > 2000) return "black";
        if (row.original.margin > 1000) return "black";
        if (row.original.margin > 800) return "black";
      } else {
        if (row.original.margin > 5000) return "white";
        if (row.original.margin > 4000) return "white";
        if (row.original.margin > 3000) return "black";
        if (row.original.margin > 2000) return "black";
        if (row.original.margin > 1000) return "black";
      }

      if (row.original.fixed) return "white";
      return "white";
    }
    if (cell.column.id === "marginLevel") {
      if (row.original.email == "LIB1" || row.original.email.includes("NEST") || mql4Protocol == "B") {
        if (row.original.marginLevel < 250) return "white";
        if (row.original.marginLevel < 800) return "black";
        if (row.original.marginLevel < 1000) return "black";
        if (row.original.marginLevel < 1200) return "black";
        if (row.original.marginLevel < 1400) return "black";
      } else {
        if (row.original.marginLevel < 150) return "white";
        if (row.original.marginLevel < 300) return "black";
        if (row.original.marginLevel < 400) return "black";
        if (row.original.marginLevel < 500) return "black";
        if (row.original.marginLevel < 800) return "black";
      }

      if (row.original.fixed) return "white";
      return "white";
    }
    if (row.original.fixed) return "white";
    return "white";
  };

  return (
    <TableContainer
      component={Paper}
      style={{ width: "100%", height: "100%", overflow: "auto", backgroundColor: "transparent" }}
    >
      <Table {...getTableProps()} stickyHeader>
        <TableHead>
          {headerGroups.map((headerGroup) => (
            <TableRow {...headerGroup.getHeaderGroupProps()} style={{ backgroundColor: "transparent" }}>
              {headerGroup.headers.map((column) => (
                <TableCell
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={{
                    backgroundColor: "transparent",
                    color: "white",
                    fontWeight: "bold",
                  }}
                >
                  <TableSortLabel
                    active={column.isSorted}
                    direction={column.isSortedDesc ? "desc" : "asc"}
                    style={{
                      "&.MuiTableSortLabel-root": {
                        color: "white",
                      },
                      "&.MuiTableSortLabel-root:hover": {
                        color: "blue",
                      },
                      "&.Mui-active": {
                        color: "blue",
                      },
                      "& .MuiTableSortLabel-icon": {
                        color: "blue !important",
                      },
                      color: column.isSorted ? "white" : "white",
                    }}
                  >
                    {column.render("Header")}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody {...getTableBodyProps()}>
          {rows.map((row) => {
            prepareRow(row);
            return (
              <TableRow {...row.getRowProps()} style={{ backgroundColor: "transparent" }}>
                {row.cells.map((cell) => (
                  <TableCell
                    {...cell.getCellProps()}
                    style={{
                      padding: "10px",
                      color: getCellTextColor(row, cell),
                      backgroundColor: getCellColor(row, cell),
                    }}
                  >
                    {cell.render("Cell")}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MQL4Page;
